import { createReducer } from '@reduxjs/toolkit';
import { endOfDay } from 'date-fns';

import { FetchStatus, RangeType } from '../../enums';
import * as actions from './actions';
import { IPhysiologicalDataState } from './types';
import { getDateForDirection, getDateForRangeType, parsePhysiologicalData } from './utils';

export const rangeInitialState = {
  rangeType: RangeType.WEEK,
  currentDate: endOfDay(Date.now()).getTime(),
};

export const initialState: IPhysiologicalDataState = {
  ...rangeInitialState,
  status: {
    physiologicalData: FetchStatus.IDLE,
    cuffMeasurements: FetchStatus.IDLE,
  },
};

export const physiologicalDataReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.resetPhysiologicalData, () => initialState)
    .addCase(actions.changeRangeType, (state, action) => {
      const { rangeType } = action.payload;
      state.currentDate = getDateForRangeType(rangeType, state.currentDate, state.rangeType);
      state.rangeType = rangeType;
    })
    .addCase(actions.changeDateRange, (state, action) => {
      const { direction } = action.payload;
      state.currentDate = getDateForDirection(direction, state.rangeType, state.currentDate);
    })
    .addCase(actions.resetToDefaultViewAndRange, (state) => {
      state.rangeType = rangeInitialState.rangeType;
      state.currentDate = rangeInitialState.currentDate;
    })
    .addCase(actions.fetchPhysiologicalData, (state) => {
      state.status.physiologicalData = FetchStatus.LOADING;
    })
    .addCase(actions.fetchPhysiologicalDataSucceeded, (state, action) => {
      state.status.physiologicalData = FetchStatus.SUCCESS;
      const { physiologicalData, patient, rangeType } = action.payload;
      state.physiologicalData = parsePhysiologicalData(physiologicalData, rangeType, patient.countryKey);
    })
    .addCase(actions.fetchPhysiologicalDataFailed, (state) => {
      state.status.physiologicalData = FetchStatus.FAILURE;
    })
    .addCase(actions.fetchCuffMeasurements, (state) => {
      state.status.cuffMeasurements = FetchStatus.LOADING;
    })
    .addCase(actions.fetchCuffMeasurementsSucceeded, (state, action) => {
      state.status.cuffMeasurements = FetchStatus.SUCCESS;
      state.cuffMeasurements = action.payload.physiologicalData;
    })
    .addCase(actions.fetchCuffMeasurementsFailed, (state) => {
      state.status.cuffMeasurements = FetchStatus.FAILURE;
    });
});
